export const cards = `
.cards {
  text-align: center;
  
  > div {
  
    ul, ol {
			list-style-position: inside;		
		}

    > ul, > ol { 
      display: inline-block;
      margin-left: 0px;
    }
  }

}
`;
